
const getCookie = ( cookieName, path ) => {
    const cookie = JSON.parse(localStorage.getItem( cookieName ));

    if( cookie && cookie.hasOwnProperty(path) ) {
        return cookie[path];
    }

    return ( cookie !== null ? cookie : false );
}

export default getCookie;